import ProspectorProApiHandler from './ProspectorProApiHandler';
import AgentService from './AgentService';
import ContactService from './ContactService';
import CrmProviderService from './CrmProviderService';
import ProspectService from './ProspectService';
import ActivityService from './ActivityService';
import ProspectorService from './ProspectorService';

const services = {
  agent: new AgentService(ProspectorProApiHandler),
  contact: new ContactService(ProspectorProApiHandler),
  crmProvider: new CrmProviderService(ProspectorProApiHandler),
  prospect: new ProspectService(ProspectorProApiHandler),
  activity: new ActivityService(ProspectorProApiHandler),
  prospector: new ProspectorService(ProspectorProApiHandler),
};

export default services;
